module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/clinic-7099d3060bf16f1efa064be593e9ff6f.svg";